<div class="tab-content" [class.active-tab]="isActive">
  @if (tabState$ | async; as tabState) {
  <!-- Use absolute positioning for loading indicator to prevent layout shifts -->
  @if (tabState.loading && !tabState.loaded) {
  <div @fadeInOut class="loading-indicator">
    <div class="loading-content">
      <mat-progress-spinner
        diameter="24"
        mode="indeterminate"
      ></mat-progress-spinner>
      <span>Indlæser indhold...</span>
    </div>
  </div>
  }
  <!-- Always render content without conditional display -->
  <div class="content-wrapper" [class.content-loaded]="tabState.loaded">
    <app-dynamic-template [slug]="slug" [dynamicOnly]="true">
    </app-dynamic-template>
  </div>
  <!-- Error overlay -->
  @if (tabState.failed) {
  <div @fadeInOut class="error-indicator">
    <div class="error-content">
      <mat-icon class="error-icon">error_outline</mat-icon>
      <h3>Indlæsningen mislykkedes</h3>
      <p>Der opstod et problem under indlæsningen af indholdet.</p>
      <button mat-raised-button color="primary" (click)="reload()">
        <mat-icon>refresh</mat-icon> Prøv igen
      </button>
    </div>
  </div>
  } }
</div>
